// @ts-nocheck — mixin methods are composed onto BackendService at runtime; instance API is typed via adminBackendServiceInterface.ts.
import type BaseBackendService from '../BaseBackendService';

export const adminBackendServiceInvestorStatusMixin = {
  promoteToLead(id: string, opts?: { overrideFundStatusRestriction?: boolean }) {
    return this.authApiMutateAuthed<void>(
      `investors/${id}/promoteToLead`,
      'PATCH',
      opts,
      () => undefined,
    );
  },

  submitEOI(
    id: string,
    indicativeInvestment: number,
    opts?: { overrideFundStatusRestriction?: boolean },
  ) {
    return this.authApiMutateAuthed<void>(
      `investors/${id}/submitEOI`,
      'POST',
      { indicativeInvestment, ...opts },
      () => undefined,
    );
  },

  withdrawEOI(id: string, opts?: { overrideFundStatusRestriction?: boolean }) {
    return this.authApiMutateAuthed<void>(
      `investors/${id}/withdrawEOI`,
      'PATCH',
      opts,
      () => undefined,
    );
  },

  promoteToOpportunity(
    id: string,
    preferredInvestment: number,
    opts?: { overrideFundStatusRestriction?: boolean },
  ) {
    return this.authApiMutateAuthed<void>(
      `investors/${id}/promoteToOpportunity`,
      'PATCH',
      { preferredInvestment, ...opts },
      () => undefined,
    );
  },

  demoteToCandidate(id: string, opts?: { overrideFundStatusRestriction?: boolean }) {
    return this.authApiMutateAuthed<void>(
      `investors/${id}/demoteToCandidate`,
      'PATCH',
      opts,
      () => undefined,
    );
  },

  demoteToLead(id: string, opts?: { overrideFundStatusRestriction?: boolean }) {
    return this.authApiMutateAuthed<void>(
      `investors/${id}/demoteToLead`,
      'PATCH',
      opts,
      () => undefined,
    );
  },

  commitInvestment(
    id: string,
    committedInvestment: number,
    opts?: { overrideFundStatusRestriction?: boolean },
  ) {
    return this.authApiMutateAuthed<void>(
      `investors/${id}/commitInvestment`,
      'PATCH',
      { committedInvestment, ...opts },
      () => undefined,
    );
  },

  demoteToOpportunity(id: string, opts?: { overrideFundStatusRestriction?: boolean }) {
    return this.authApiMutateAuthed<void>(
      `investors/${id}/demoteToOpportunity`,
      'PATCH',
      opts,
      () => undefined,
    );
  },
} satisfies ThisType<BaseBackendService>;
